import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const http_options = {
	headers: new HttpHeaders({
		'Content-Type': 'application/json'
	})
};

class OnAccountForm {
	account_name:string;
	address : string;
	branch: string;
	contact_no: string;
}

@Injectable()
export class OnAccountService {

	private url = environment.url

	constructor(private http: HttpClient) { }


	addNewAccount(form): Observable<string>{
		return this.http.post<string>(this.url + '/masters/onaccount/submit', form, http_options);
	};

	getAllOnAccount(): Observable<OnAccountForm[]> {
		return this.http.get<OnAccountForm[]>(this.url + '/masters/onaccount/all');
	};
	getAccountFormWith(name:string): Observable<OnAccountForm[]> {
		return this.http.get<OnAccountForm[]>(this.url + '/masters/onaccount/get/' + name);
	};


	// delete on account
	deleteOnAccount(id): Observable<string>{
		return this.http.post<string>(this.url + '/masters/onaccount/delete', id);
	};

}




// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/_services/_masters/on-account.service.ts